// We import css cause were using webpack
import LazyLoad from "vanilla-lazyload";

import Toggle from "./components/toggle";
import { scrollDirection } from "./components/scrollDirection";
import Menu from "./components/menu";

import Alpine from "alpinejs";
window.Alpine = Alpine;
Alpine.start();

const toggle = new Toggle();
const ScrollDirection = new scrollDirection();
const menu = new Menu();

document.addEventListener("DOMContentLoaded", () => {
	console.log("Theme loaded");

	// START EVOLUZIONE
	// jQuery(document).on('click', 'form.klaviyo-form button.go952291206', function(event) {

	// 	console.log('Evoluzione klaviyo Push');

	// 	var itemklaviyo = {
	// 		"pageUrl": window.location.href,
	// 	};
	// 	klaviyo.push(['track', 'formSubmitted', itemklaviyo]);

	// });

	function waitForElm(selector) {
		return new Promise((resolve) => {
			if (document.querySelector(selector)) {
				return resolve(document.querySelector(selector));
			}

			const observer = new MutationObserver(() => {
				const el = document.querySelector(selector);
				if (el) {
					resolve(el);
					observer.disconnect();
				}
			});

			observer.observe(document.body, { childList: true, subtree: true });
		});
	}

	waitForElm("form.klaviyo-form button.go2534619395").then((button) => {
		console.log("✅ Bottone Klaviyo trovato:", button);

		button.addEventListener("click", (event) => {
			console.log("📤 Click bottone tracciamento");

			const itemklaviyo = { pageUrl: window.location.href };

			if (
				typeof klaviyo !== "undefined" &&
				typeof klaviyo.push === "function"
			) {
				klaviyo.push(["track", "formSubmitted", itemklaviyo]);
				console.log("✅ klaviyo.push eseguito", itemklaviyo);
			} else {
				console.warn("⚠️ klaviyo non è disponibile");
			}
		});
	});

	// document.addEventListener("click", function (event) {
	// 	// Verifica se l'elemento cliccato è un pulsante all'interno di un form con le classi specificate
	// 	if (event.target.matches("form.klaviyo-form button.go2534619395")) {
	// 		console.log("Evoluzione klaviyo Push");
	// 		// Ottieni l'URL della pagina corrente
	// 		var pageUrl = window.location.href;

	// 		// Crea l'oggetto itemklaviyo con l'URL della pagina
	// 		var itemklaviyo = {
	// 			pageUrl: pageUrl,
	// 		};

	// 		// Esegui il tracking utilizzando klaviyo.push
	// 		klaviyo.push(["track", "formSubmitted", itemklaviyo]);
	// 	}
	// });

	// END EVOLUZIONE

	// Any global JS goes here, otherwise inline JS at the bottom

	// wait until any element needed has loaded
	function waitForElm(selector) {
		return new Promise((resolve) => {
			if (document.querySelector(selector)) {
				return resolve(document.querySelector(selector));
			}
			const observer = new MutationObserver((mutations) => {
				if (document.querySelector(selector)) {
					resolve(document.querySelector(selector));
					observer.disconnect();
				}
			});
			observer.observe(document.body, {
				childList: true,
				subtree: true,
			});
		});
	}

	// init lazy load
	new LazyLoad();

	// Remove recharge link on login page
	window.rcLoginAccessLink = {
		disableInjection: true,
	};

	// product quick add toggle -- START --

	// setup selectors
	let quickAddOpenBtn = document.querySelectorAll(".quickAddOpen__btn");
	let quickAddCloseBtn = document.querySelectorAll(".quickAddClose__btn");
	let quickAddOverlayEl = document.querySelectorAll(".quickAdd__overlay");
	let prodSubOnce = document.querySelectorAll(".subOnce");
	let prodSubSave = document.querySelectorAll(".subSave");
	let prodSubInput = document.querySelectorAll(".subInput:not(.fbtSubInput)");
	let prodSub__ticks = document.querySelectorAll(".prodSub__benefits");
	let coll_overlay = document.querySelector(".coll_overlay");
	let hasSubscription = document.querySelector(".hasSubscription");
	let sellingPlansContainer = document.querySelectorAll(
		".selling_plan_selectContainer"
	);

	// for each featured product btn, add a click listener to toggle the quick add overlay
	quickAddOpenBtn.forEach((item, i) => {
		item.addEventListener("click", () => {
			quickAddOverlayEl[i].classList.toggle("hidden");
			if (quickAddOverlayEl[i].closest(".coll_prod") != null) {
				quickAddOverlayEl[i]
					.closest(".coll_prod")
					.classList.add("coll_prod__selected");
				coll_overlay.classList.remove("hidden");
			}
		});
		prodSubInput[i].addEventListener("change", () => {
			// console.log("Evoluzione cambio input");
			sellingPlansContainer[i].classList.toggle("opacity-10");
			sellingPlansContainer[i].classList.toggle("cursor-not-allowed");
			sellingPlansContainer[i].classList.toggle("pointer-events-none");
			// prodSub__ticks[i].classList.toggle("opacity-10");

			if (prodSubInput[i].checked) {
				prodSubInput[i]
					.closest(".quickAdd__overlay")
					.querySelector(".selling_plan_selectContainer select")
					.setAttribute("name", "selling_plan");

				prodSubInput[i].parentElement.parentElement.parentElement
					.querySelector(".subOnce")
					.classList.add("text-gray-500");
				prodSubInput[i].parentElement.parentElement.parentElement
					.querySelector(".subSave")
					.classList.remove("text-gray-500");
			} else {
				prodSubInput[i].parentElement.parentElement.parentElement
					.querySelector(".subOnce")
					.classList.remove("text-gray-500");
				prodSubInput[i].parentElement.parentElement.parentElement
					.querySelector(".subSave")
					.classList.add("text-gray-500");

				prodSubInput[i]
					.closest(".quickAdd__overlay")
					.querySelector(".selling_plan_selectContainer select")
					.setAttribute("name", "");
			}
		});

		// prodSubOnce.addEventListener("click", () => {
		//   prodSubInput[i].checked = false;
		//   let event = new Event("change");
		//   prodSubInput[i].dispatchEvent(event);
		// });

		// prodSubSave[i].addEventListener("click", () => {
		//   prodSubInput[i].checked = true;
		//   let event = new Event("change");
		//   prodSubInput[i].dispatchEvent(event);
		// });
	});

	// for each featured product btn, add a click listener to toggle the quick add overlay
	quickAddCloseBtn.forEach((item, index) => {
		item.addEventListener("click", () => {
			quickAddOverlayEl[index].classList.toggle("hidden");
			if (quickAddOverlayEl[index].closest(".coll_prod") != null) {
				quickAddOverlayEl[index]
					.closest(".coll_prod")
					.classList.remove("coll_prod__selected");
				coll_overlay.classList.add("hidden");
			}
		});
	});

	// product quick add toggle -- END --

	// handle input add and subtract -- START --

	let add = document.querySelectorAll("[data-quantity-add]");
	let numberInput = document.querySelectorAll("[data-quantity-number]");
	let subtract = document.querySelectorAll("[data-quantity-minus]");

	if (subtract.length > 0) {
		let handleAddClick = (i) => {
			const value = (parseInt(numberInput[i].value) + 1).toString();
			numberInput[i].value = value;
		};

		let handleSubtractClick = (i) => {
			const value = (parseInt(numberInput[i].value) - 1).toString();
			numberInput[i].value =
				value <= numberInput[i].min ? numberInput[i].min : value;
		};

		add.forEach((item, i) => {
			item.addEventListener("click", () => {
				handleAddClick(i);
			});
			subtract[i].addEventListener("click", () => {
				handleSubtractClick(i);
			});
		});
	}

	// handle input add and subtract -- END --

	// handle product selection -- START --

	// This is the hidden SELECT that contains all of the product variants which is dynamically chosen when the user chooses an option in the visible SELECT
	// let productMainIdSelector = document.querySelectorAll(
	//   "select[data-add-to-cart-variant-id]"
	// );
	// This is the hidden SELECT that contains all of the product variants which is dynamically chosen when the user chooses an option in the visible SELECT
	let selectedProductIds = document.querySelectorAll(
		"[name=id]:not(.cart-upsell__input)"
	);
	console.log(selectedProductIds);
	// This is the visible SELECT's that show the product options
	let productOptionSelectors = document.querySelectorAll(
		"select[data-add-to-cart-option]"
	);
	// This is the input that holds all of the variant data for each product
	let productVariantsData = document.querySelectorAll(
		"input[data-add-to-cart-variants]"
	);
	// This is the add to cart button
	let productAddToCartBtns = document.querySelectorAll(
		"button[data-add-to-cart-btn]"
	);
	// This is all of the product forms on the current page
	let productForms = document.querySelectorAll("form[data-add-to-cart]");
	// This is the just once / sub and save inputs for collection products
	let subscribeAndSaveToggleInputs =
		document.querySelectorAll("input.subInput");
	let quickAddFBTBtns = document.querySelectorAll(".quickAddFBT");

	// wait until recharge element has loaded
	waitForElm(".rc-template__legacy-radio").then((elm) => {
		// This is the product page selling plans input container
		let subSaveProdPage = document.querySelector(".rc-option__subsave");
		let oneTimeProdPage = document.querySelector(".rc-option__onetime");
		let oneTimePrice = document.querySelector(
			".rc_widget__price--onetime "
		);
		let subSavePrice = document.querySelector(".rc_widget__price--subsave");

		// oneTimeProdPage.classList.remove("rc-text-black");
		// oneTimeProdPage.classList.add("rc-text-yellow");
		// oneTimeProdPage.classList.add("rc-option-bg");
		// subSaveProdPage.classList.add("rc-text-black");
		// oneTimePrice.classList.add("rc-option__price-white");

		// remove recharge selling plans as we're using our custom one
		document.querySelector(".rc-selling-plans").remove();

		// product page recharge toggle selling plans

		const evoluzioneCheckbox = document.getElementById(
			"js-evoluzione-checkbox-recharge"
		);
		const evoluzionePurchaseType =
			document.querySelector(".js-prodDetails");

		subSaveProdPage.addEventListener("click", (e) => {
			// console.log("Evoluzione Abbonamento Selezionato");
			evoluzioneCheckbox.checked = true; // Imposta il checkbox su "selezionato"
			evoluzionePurchaseType.classList.add(
				"evoluzione-subscription-purchase"
			);
			document
				.querySelector(".selling_plan_selectContainer select")
				.setAttribute("name", "selling_plan");
			// oneTimeProdPage.classList.remove("rc-text-yellow");
			// oneTimeProdPage.classList.add("rc-text-black");
			// subSaveProdPage.classList.remove("rc-text-black");
			// subSaveProdPage.classList.add("rc-text-yellow");
			// oneTimePrice.classList.add("rc-option__price-strike");
			// oneTimePrice.classList.remove("rc-option__price-white");
			// subSavePrice.classList.add("rc-option__price-white");
			// prodSub__ticks[0].classList.remove("opacity-10");
			// sellingPlansContainer[0]
			// 	.querySelector("select")
			// 	.classList.remove("opacity-10");
			sellingPlansContainer[0]
				.querySelector("select")
				.classList.remove("cursor-not-allowed");
			sellingPlansContainer[0]
				.querySelector("select")
				.classList.remove("pointer-events-none");
			handleProductAvailability(selectedProductIds[0].value, 0);
			return;
		});
		oneTimeProdPage.addEventListener("click", (e) => {
			console.log("Evoluzione Acquisto singolo Selezionato");
			evoluzioneCheckbox.checked = false; // Imposta il checkbox su "selezionato"

			evoluzionePurchaseType.classList.remove(
				"evoluzione-subscription-purchase"
			);

			document
				.querySelector(".selling_plan_selectContainer select")
				.setAttribute("name", "");
			// oneTimeProdPage.classList.add("rc-text-yellow");
			// oneTimeProdPage.classList.remove("rc-text-black");
			// subSaveProdPage.classList.remove("rc-text-yellow");
			// subSaveProdPage.classList.add("rc-text-black");
			// oneTimePrice.classList.remove("rc-option__price-strike");
			// oneTimePrice.classList.add("rc-option__price-white");
			// subSavePrice.classList.remove("rc-option__price-white");
			// prodSub__ticks[0].classList.add("opacity-10");
			// sellingPlansContainer[0]
			// 	.querySelector("select")
			// 	.classList.add("opacity-10");
			sellingPlansContainer[0]
				.querySelector("select")
				.classList.add("cursor-not-allowed");
			sellingPlansContainer[0]
				.querySelector("select")
				.classList.add("pointer-events-none");
			handleProductAvailability(selectedProductIds[0].value, 0);
			return;
		});
	});

	let setAddToCartBtnAvailability = (availability, index) => {
		if (productAddToCartBtns[index] != null) {
			if (availability == true) {
				// set normal styles
				productAddToCartBtns[index].classList.remove("disabled");
				// hide sold out text
				productAddToCartBtns[index]
					.querySelector(".product_soldOut")
					.classList.add("hidden");
				// hide available text
				productAddToCartBtns[index]
					.querySelector(".product_available")
					.classList.remove("hidden");
			} else {
				// set disabled styles
				productAddToCartBtns[index].classList.add("disabled");
				// show sold out text
				productAddToCartBtns[index]
					.querySelector(".product_soldOut")
					.classList.remove("hidden");
				// hide available text
				productAddToCartBtns[index]
					.querySelector(".product_available")
					.classList.add("hidden");
			}
		}
	};

	let setAddToCartBtnPrice = (
		productOneTimePrice,
		productOneTimeCompareAtPrice,
		productSubSavePrice,
		index
	) => {
		let priceToUse;
		// if subscribe option chosen, show subSave price
		// if one time then check if compare at price is empty and show that or else show normal price

		// we use this in the product page and the collection products
		// Problem: we use the switch input for the collection product and another input for the product page (due to recharge injection)
		// solution: check if the sub and save inputs are null and if so, change which inputs we use

		// something specific to only main product form
		if (
			productForms[index].classList.contains("mainProdForm") &&
			hasSubscription != null
		) {
			// For main product on prod page
			// wait until recharge element has loaded
			waitForElm("input.rc_widget__option__input--subsave").then(
				(elm) => {
					// This is the just once / sub and save inputs for collection products
					let subscribeAndSaveInputProdPage = document.querySelector(
						"input.rc_widget__option__input--subsave"
					);

					if (
						subscribeAndSaveInputProdPage.checked &&
						productSubSavePrice != null
					) {
						priceToUse = productSubSavePrice;
					} else {
						if (productOneTimePrice != null) {
							priceToUse = productOneTimePrice;
						} else {
							priceToUse = productOneTimeCompareAtPrice;
						}
					}
					const formatPrice = Intl.NumberFormat(Shopify.locale, {
						style: "currency",
						currency: Shopify.currency.active,
					}).format(priceToUse / 100);
					productAddToCartBtns[index].querySelector(
						".prodPrice"
					).textContent = formatPrice;
					// the product price is hidden by default on the prod page as it needs to be calculated first
					if (
						productAddToCartBtns[index].querySelector(
							".prodPrice"
						) != null &&
						productAddToCartBtns[index].querySelector(
							".prodPrice"
						) != undefined
					) {
						if (
							productAddToCartBtns[index]
								.querySelector(".prodPrice")
								.classList.contains("hidden")
						) {
							productAddToCartBtns[index]
								.querySelector(".prodPrice")
								.classList.remove("hidden");
						}
					}
				}
			);
		} else {
			const prod = productAddToCartBtns[index];
			if (prod != null && prod != undefined) {
				if (
					productAddToCartBtns[index]
						.querySelector(".prodPrice")
						.classList.contains("hidden")
				) {
					productAddToCartBtns[index]
						.querySelector(".prodPrice")
						.classList.remove("hidden");
				}
				if (
					subscribeAndSaveToggleInputs[index].checked &&
					productSubSavePrice != null
				) {
					priceToUse = productSubSavePrice;
				} else {
					if (productOneTimePrice != null) {
						priceToUse = productOneTimePrice;
					} else {
						priceToUse = productOneTimeCompareAtPrice;
					}
				}
			}
		}

		const formatPrice = Intl.NumberFormat(Shopify.locale, {
			style: "currency",
			currency: Shopify.currency.active,
		}).format(priceToUse / 100);
		if (productAddToCartBtns[index] == null) {
			// minus the index as we skip the first (main product add to cart to cart button)
			// check if this is null as we could be on the cart page which we wouldn't need to skip
			if (quickAddFBTBtns[index] != null) {
				quickAddFBTBtns[index].querySelector(".prodPrice").textContent =
					formatPrice;
			} else if (quickAddFBTBtns[index - 1] != null) {
				quickAddFBTBtns[index - 1].querySelector(
					".prodPrice"
				).textContent = formatPrice;
			}
		} else {
			productAddToCartBtns[index].querySelector(
				".prodPrice"
			).textContent = formatPrice;
		}
	};

	let handleProductAvailability = (productId, index) => {
		let productVariantData = JSON.parse(productVariantsData[index].value);
		let productAvailable = false;
		let productOneTimePrice;
		let productOneTimeCompareAtPrice;
		let productSubSavePrice;
		productVariantData.forEach((item) => {
			if (item.id == productId) {
				productAvailable = item.available;
				productOneTimePrice = item.price;
				productOneTimeCompareAtPrice = item.compare_at_price;
				if (
					item.selling_plan_allocations != undefined &&
					item.selling_plan_allocations[0] != undefined
				) {
					productSubSavePrice =
						item.selling_plan_allocations[0].price;
				}
			}
		});
		setAddToCartBtnAvailability(productAvailable, index);
		setAddToCartBtnPrice(
			productOneTimePrice,
			productOneTimeCompareAtPrice,
			productSubSavePrice,
			index
		);
	};

	// Choose a select based on text content instead of value as we need to dynamically update the main product select
	// The two selects only have the option value in common so we base the correlation on these values
	// When the user selects a product option, we obtain the product option value and update the main selector selected index through searching for the select option with this text content
	productForms.forEach((item, index) => {
		// user chooses product option
		if (
			item.querySelector("select[data-add-to-cart-option]") != undefined
		) {
			item.querySelector(
				"select[data-add-to-cart-option]"
			).addEventListener("change", (e) => {
				item.querySelector(
					"select[data-add-to-cart-variant-id]"
				).selectedIndex = [
					...item.querySelector("select[data-add-to-cart-variant-id]")
						.options,
				].findIndex(
					(option) =>
						option.text ===
						item.querySelector("select[data-add-to-cart-option]")
							.options[
							item.querySelector(
								"select[data-add-to-cart-option]"
							).selectedIndex
						].text
				);
				//   update out of stock button / prices
				handleProductAvailability(
					item.querySelector("select[data-add-to-cart-variant-id]")
						.value,
					index
				);
			});
		}
	});

	subscribeAndSaveToggleInputs.forEach((item, index) => {
		// user toggles sub and save and one time
		item.addEventListener("change", (e) => {
			//   update out of stock button / prices
			handleProductAvailability(selectedProductIds[index].value, index);
		});
	});

	// initial availability check on currently selected products
	if (subtract.length > 0) {
		selectedProductIds.forEach((item, index) => {
			// user toggles sub and save and one time
			//   update out of stock button / prices
			handleProductAvailability(item.value, index);
		});
	}
	// handle product selection -- END --

	// handle faq tabs -- START --

	let faq_parent__questions = document.querySelectorAll(
		".faqSec .faq_parent"
	);
	let faq_child__answers = document.querySelectorAll(".faqSec .faq_answer");
	let faq_parent__plus = document.querySelectorAll(".faqSec .transform");

	faq_parent__questions.forEach((item, index) => {
		item.addEventListener("click", () => {
			faq_child__answers[index].classList.toggle("max-h-0");
			faq_child__answers[index].classList.toggle("h-0");
			faq_child__answers[index].classList.toggle("pt-2");
			faq_child__answers[index].classList.toggle("h-auto");
			faq_child__answers[index].classList.toggle("overflow-hidden");
			faq_child__answers[index].classList.toggle("opacity-0");
			faq_child__answers[index].classList.toggle("max-h-9999px");
			faq_parent__plus[index].classList.toggle("rotate-45");
			faq_parent__plus[index].classList.toggle("text-3xl");
		});
	});

	// handle faq tabs -- END --

	// handle QuickAdd Frequently Bought Together -- START --
	// Fbt = Frequently Bought Together
	let fbtQuickAddOpenBtns = document.querySelectorAll(
		".fbt_quick_add_toggle"
	);
	let fbt_idSelects = document.querySelectorAll(".fbt_id");
	let fbt_quantities = 1;
	//let fbt_quantities = document.querySelectorAll(".fbt_qty");
	let fbt_quantityBtns = document.querySelectorAll(".qtyChange");
	let quickAddFbtIncludeInputs =
		document.querySelectorAll("input.fbtInclude");
	let fbtProdSubInputs = document.querySelectorAll(".fbtSubInput");
	let fbtAddToCartBtn = document.querySelector(".fbt__add-to-cart");
	let fbtProdCountEl = document.querySelector("span.fbt-count");
	let amount_needed = document.querySelectorAll(".amount_needed");
	let fbtProds = [];
	let fbtProdCount = 0;

	document.addEventListener("DOMContentLoaded", () => {});

	// disable the fbt add to cart by default as nothing is selected
	if (fbtAddToCartBtn != null) {
		fbtAddToCartBtn.classList.add("pointer-events-none");
		fbtAddToCartBtn.classList.add("opacity-20");
	}

	let calculateFbtProdCount = () => {
		fbtProdCount = 0;
		fbtQuickAddOpenBtns.forEach((item, i) => {
			if (quickAddFbtIncludeInputs[i].checked) {
				console.log("ITEMS", fbt_quantities);
				fbtProdCount += parseInt(1);
			}
		});
		if (fbtProdCount == 0) {
			fbtAddToCartBtn.innerHTML = "Aggiungi i prodotti";
		} else {
			fbtAddToCartBtn.innerHTML =
				"Aggiungi " + fbtProdCount + "  prodotti al carrello";
		}
		//fbtProdCountEl.innerHTML = fbtProdCount;
	};

	// fbt_quantityBtns.forEach((item) => {
	//   item.addEventListener("click", () => {
	//     if(fbt_quantities.length > 0){
	//       calculateFbtProdCount();
	//     }
	//   });
	// });

	// for each fbt, add a click listener to toggle the quick add overlay
	fbtQuickAddOpenBtns.forEach((item, i) => {
		if (item != undefined && item != null) {
			item.addEventListener("click", (e) => {
				console.log("quantities", fbt_quantities.length);
				if (fbt_quantities > 0) {
					calculateFbtProdCount();
				}
				// stop the event bubbling to the input listener which will fire this again
				if (e.target.tagName !== "INPUT") {
					if (!quickAddFbtIncludeInputs[i].checked) {
						if (
							quickAddOverlayEl[i] != undefined &&
							quickAddOverlayEl[i] != null
						) {
							quickAddOverlayEl[i].classList.toggle("hidden");
						}
					}
				}
				// change state of fbt add to cart button depending on how many are selected
				if (fbtProdCount > 0) {
					fbtAddToCartBtn.classList.remove("pointer-events-none");
					fbtAddToCartBtn.classList.remove("opacity-20");
				} else {
					fbtAddToCartBtn.classList.add("pointer-events-none");
					fbtAddToCartBtn.classList.add("opacity-20");
				}
				console.log(fbtProdCount);
			});
		}
		if (fbtProdSubInputs[i] != undefined && fbtProdSubInputs[i] != null) {
			fbtProdSubInputs[i].addEventListener("change", () => {
				fbtProdSubInputs[i].parentElement.parentElement.parentElement
					.querySelector(".selling_plan_selectContainer")
					.classList.toggle("opacity-10");
				fbtProdSubInputs[i].parentElement.parentElement.parentElement
					.querySelector(".selling_plan_selectContainer")
					.classList.toggle("cursor-not-allowed");
				fbtProdSubInputs[i].parentElement.parentElement.parentElement
					.querySelector(".selling_plan_selectContainer")
					.classList.toggle("pointer-events-none");
				fbtProdSubInputs[i].parentElement.parentElement.parentElement
					.querySelector(".prodSub__benefits")
					.classList.toggle("opacity-10");

				if (fbtProdSubInputs[i].checked) {
					fbtProdSubInputs[i]
						.closest(".quickAdd__overlay")
						.querySelector(".selling_plan_selectContainer select")
						.setAttribute("name", "selling_plan");
					prodSubSave[i].classList.remove("text-gray-500");
					prodSubOnce[i].classList.add("text-gray-500");
				} else {
					prodSubOnce[i].classList.remove("text-gray-500");
					prodSubSave[i].classList.add("text-gray-500");
					fbtProdSubInputs[i]
						.closest(".quickAdd__overlay")
						.querySelector(".selling_plan_selectContainer select")
						.setAttribute("name", "");
				}
			});
		}
		if (prodSubOnce[i] != undefined && prodSubOnce[i] != null) {
			// prodSubOnce[i].addEventListener("click", () => {
			//   fbtProdSubInputs[i].checked = false;
			//   let event = new Event("change");
			//   fbtProdSubInputs[i].dispatchEvent(event);
			// });
			// prodSubSave[i].addEventListener("click", () => {
			//   fbtProdSubInputs[i].checked = true;
			//   let event = new Event("change");
			//   fbtProdSubInputs[i].dispatchEvent(event);
			// });
		}
	});

	// if (fbtAddToCartBtn != null) {
	// 	fbtAddToCartBtn.addEventListener("click", () => {
	// 		// get all products added to include
	// 		fbtProds = [];
	// 		quickAddFbtIncludeInputs.forEach((item, index) => {
	// 			if (item.checked) {
	// 				// check for selling plan
	// 				let subAndSaveChecked = item
	// 					.closest(".fbt_item-container")
	// 					.querySelector("select[name=selling_plan]");
	// 				let selling_plan = item
	// 					.closest(".fbt_item-container")
	// 					.querySelector("select.fbt-selling-plans");
	// 				//let quantity = item.closest(".fbt_item-container").querySelector("#quantity").value;
	// 				if (selling_plan != null && subAndSaveChecked != null) {
	// 					fbtProds.push({
	// 						id: fbt_idSelects[index].value,
	// 						selling_plan: selling_plan.value,
	// 						quantity: 1,
	// 					});
	// 				} else {
	// 					fbtProds.push({
	// 						id: fbt_idSelects[index].value,
	// 						quantity: 1,
	// 					});
	// 				}
	// 			}
	// 		});

	// 		// ensure products have been added to the cart before carrying out the post
	// 		if (fbtProds.length == 0) {
	// 			alert(
	// 				"You must select at least 1 product before adding to the cart."
	// 			);
	// 		} else {
	// 			axios({
	// 				method: "post",
	// 				url: window.Shopify.routes.root + "cart/add.js",
	// 				responseType: "json",
	// 				data: { items: fbtProds },
	// 			})
	// 				.then((response) => {
	// 					setTimeout(() => {
	// 						window.location.reload();
	// 					}, 500);
	// 					// response if needed
	// 					// if on cart page, re-load the page

	// 					// if (document.querySelector('body').classList.contains('template-cart')) {
	// 					// window.location.reload();
	// 					// }
	// 				})
	// 				.catch((error) => {
	// 					console.error("Error:", error.response);
	// 					//alert("Error, please refresh and try again. ");
	// 				});
	// 		}
	// 	});
	// }

	// handle QuickAdd Frequently Bought Together -- END --

	// handle Opinew title injection -- START --

	// waitForElm(
	// 	"span.opw-starSummaryOverallScoreFontSize.opw-navbarTextColor.opw-pr-2"
	// ).then((elm) => {
	// 	let customerReviewsTitle = document.querySelector(
	// 		".customer-reviews-title"
	// 	);
	// 	let opinewTitle = document.querySelector(
	// 		"span.opw-starSummaryOverallScoreFontSize.opw-navbarTextColor.opw-pr-2"
	// 	);
	// 	opinewTitle.insertAdjacentElement("beforebegin", customerReviewsTitle);
	// 	customerReviewsTitle.classList.remove("hidden");
	// });

	// handle Opinew title injection -- END --

	// handle header scroll animation -- START --
	// let header = document.querySelector("header");
	// let lastScrollY = 0;
	// window.addEventListener("scroll", () => {
	//   if (window.scrollY > 110) {
	//     // check if user scrolled up
	//     // Down
	//     if (lastScrollY - window.scrollY < 0) {
	//       header.classList.add("header-scrolled");
	//       // Up
	//     } else if (lastScrollY - window.scrollY > 0) {
	//       header.classList.remove("header-scrolled");
	//     }
	//     // update curr value
	//     lastScrollY = window.scrollY;
	//     // we are back at the top so remove it and place menu back to normal
	//   } else {
	//     header.classList.remove("header-scrolled");
	//   }
	// });

	// handle header scroll animation -- END --

	// handle header mobile menu -- START --

	let headerMobileMenu = document.querySelector(".mobile-menu");
	let headerMobileMenuTrigger = document.querySelector(
		".mobile-menu--trigger"
	);
	let headerMobileMainTopNav = document.querySelector(".menu__main-top-nav");
	let mobileSearchAccountEl = document.querySelector(
		".mobile-search-account"
	);
	let mobileParentLinks = document.querySelectorAll(
		".mobile-menu .link-mobile--parent"
	);
	let mobileBackLinks = document.querySelectorAll(".mobile-menu .link-back");

	headerMobileMenuTrigger.addEventListener("click", () => {
		document.querySelector("body").classList.toggle("overflow-hidden");
		document.querySelector("html").classList.toggle("overflow-hidden");
		headerMobileMenuTrigger.classList.toggle("mobile-menu--trigger-open");
		headerMobileMenu.classList.toggle("mobile-menu--open");
		headerMobileMainTopNav.classList.toggle("menu__main-top-nav--open");
	});

	// going down a level
	mobileParentLinks.forEach((item) => {
		item.addEventListener("click", (e) => {
			item.parentElement
				.querySelector("ul")
				.classList.toggle("-left-full");
			mobileSearchAccountEl.classList.toggle("account_search_bottom");
		});
	});

	// going backup a level
	mobileBackLinks.forEach((item) => {
		item.addEventListener("click", (e) => {
			item.closest("ul.child_links").classList.toggle("-left-full");
			mobileSearchAccountEl.classList.toggle("account_search_bottom");
		});
	});

	// handle header mobile menu -- END --

	// handle header desktop menu -- START --

	let headerMainTopNav = document.querySelector("#shopify-section-header");
	let desktopParentLinks = document.querySelectorAll(".link-desktop--parent");
	let desktopMenuItems = document.querySelectorAll(".desktop-menu-item");

	headerMainTopNav.addEventListener("mouseenter", (e) => {
		if (window.innerWidth > 1023) {
			headerMobileMainTopNav.classList.add("menu__main-top-nav--open");
		}
	});

	headerMainTopNav.addEventListener("mouseleave", (e) => {
		if (window.innerWidth > 1023) {
			headerMobileMainTopNav.classList.remove("menu__main-top-nav--open");
		}
	});

	let closeAllMenus = () => {
		desktopParentLinks.forEach((item) => {
			item.parentElement
				.querySelector(".child_links")
				.classList.add("opacity-0");
			item.parentElement
				.querySelector(".child_links")
				.classList.remove("opacity-100");
			item.parentElement
				.querySelector(".child_links")
				.classList.add("pointer-events-none");
		});
	};

	// on hover parent element, show children
	desktopMenuItems.forEach((item) => {
		item.addEventListener("mouseenter", () => {
			closeAllMenus();
		});
	});

	// on hover parent element, show children
	desktopParentLinks.forEach((item) => {
		item.addEventListener("mouseenter", () => {
			closeAllMenus();
			item.parentElement
				.querySelector(".child_links")
				.classList.remove("opacity-0");
			item.parentElement
				.querySelector(".child_links")
				.classList.add("opacity-100");
			item.parentElement
				.querySelector(".child_links")
				.classList.remove("pointer-events-none");
		});
	});
	// on hover parent element, show children
	desktopParentLinks.forEach((item) => {
		item.parentElement
			.querySelector(".child_links")
			.addEventListener("mouseleave", () => {
				item.parentElement
					.querySelector(".child_links")
					.classList.add("opacity-0");
				item.parentElement
					.querySelector(".child_links")
					.classList.remove("opacity-100");
				item.parentElement
					.querySelector(".child_links")
					.classList.add("pointer-events-none");
			});
	});

	// handle header desktop menu -- END --

	// handle country selector - WEGLOT/CUSTOM -- START --
	// waitForElm(".country-selector").then((elm) => {
	// 	let customCountrySelectorDesktop = document.querySelector(
	// 		"#customCountrySelector-desktop"
	// 	);
	// 	let customCountrySelectorMobile = document.querySelector(
	// 		"#customCountrySelector-mobile"
	// 	);
	// 	let weglotCountrySelectorListItems =
	// 		document.querySelectorAll(".wg-li");
	// 	weglotCountrySelectorListItems.forEach((item) => {
	// 		// loop through all the items in the list
	// 		let langCode = item.getAttribute("data-l");
	// 		let opt = document.createElement("option");
	// 		opt.value = langCode;
	// 		opt.innerHTML = langCode;

	// 		customCountrySelectorDesktop.appendChild(opt.cloneNode(true));
	// 		customCountrySelectorMobile.appendChild(opt.cloneNode(true));
	// 	});

	// 	customCountrySelectorDesktop.addEventListener("change", () => {
	// 		let weglotLiItemToClick = Array.from(
	// 			weglotCountrySelectorListItems
	// 		).filter(
	// 			(item) =>
	// 				item.getAttribute("data-l") ==
	// 				customCountrySelectorDesktop.value.toLowerCase()
	// 		);
	// 		weglotLiItemToClick[0].querySelector("a").click(); // Dispatch the event.
	// 	});

	// 	customCountrySelectorMobile.addEventListener("change", () => {
	// 		let weglotLiItemToClick = Array.from(
	// 			weglotCountrySelectorListItems
	// 		).filter(
	// 			(item) =>
	// 				item.getAttribute("data-l") ==
	// 				customCountrySelectorMobile.value.toLowerCase()
	// 		);
	// 		weglotLiItemToClick[0].querySelector("a").click(); // Dispatch the event.
	// 	});
	// });

	// handle country selector - WEGLOT/CUSTOM -- END --

	// Quiz Page Logic To Remove Title Text -- START --

	let quiz = document.querySelector(".quiz_section");

	if (quiz != null) {
		// initialise Request
		let openRequest = XMLHttpRequest.prototype.open;

		function onRequestFireStateChange(event) {
			// fires on every loadEnd event
			// use this to determine which XHR object fired the change event
			// initial start request of the quiz
			if (
				event.currentTarget._url ==
				"https://app.octaneai.com/_quiz_/start"
			) {
				// on quiz load
			} else if (
				event.currentTarget._url ==
				"https://app.octaneai.com/_quiz_/submit"
			) {
				// on quiz submit option
				document
					.querySelector(".quiz_section .quiz-start-text")
					.classList.add("hidden");
				setTimeout(() => {
					window.scroll({ top: 0, left: 0, behavior: "smooth" });
				}, 100);
			} else if (
				event.currentTarget._url ==
				"https://app.octaneai.com/_quiz_/back"
			) {
				// on quiz submit back option
			}
		}

		XMLHttpRequest.prototype.open = function () {
			// when an XHR object is opened, add a listener for its loadEnd events
			this.addEventListener("loadend", onRequestFireStateChange);
			// run the real `open`
			openRequest.apply(this, arguments);
		};
	}

	// Quiz Page Logic To Remove Title Text -- END --

	// Quiz Page Logic To Load Dynamic Products In Result -- START --

	waitForElm('[data-element="oct-quiz-resultitem"]').then((elm) => {
		quiz.classList.add("quiz_section_results");
		const quizResultsTitle = document.querySelector(".quiz-results-title");
		const productsContainer = document.querySelectorAll(
			".coll_prods .coll_prod"
		);
		const productsWrapper = document.querySelector(".results_prods");
		const quizRendered = document.querySelector(".octane-ai-quiz-rendered");
		quizResultsTitle.classList.remove("hidden");
		const result = document
			.querySelector(".octane-ai-quiz-rendered")
			.querySelectorAll('[tabindex="-1"]');
		let resultArr = [];
		result.forEach((element, index) => {
			resultArr.push(
				element.textContent.split(" ").join("-").toLowerCase()
			);
		});
		productsContainer.forEach((element, index) => {
			let prodName = element.getAttribute("data-name");

			resultArr.forEach((res) => {
				if (res == prodName) {
					element.classList.remove("hidden");
				}
			});
		});
		productsWrapper.classList.remove("hidden");
	});

	// Quiz Page Logic To Load Dynamic Products In Result -- END --

	// Add To Cart Logic - Remove Product From Cart Upsell Pool -- START --
	let cartUpsellAddToCartBtns = document.querySelectorAll(
		".cart-upsell-item__atc"
	);
	if (cartUpsellAddToCartBtns.length == 0) {
		document
			.querySelector(".go-cart-drawer__upsell")
			.classList.add("hidden");
	}

	let checkRemaininUpsellItems = () => {
		return document.querySelectorAll(".cart-upsell__item:not(.hidden)")
			.length;
	};

	cartUpsellAddToCartBtns.forEach((item) => {
		item.addEventListener("click", () => {
			item.closest(".cart-upsell__item").classList.add("hidden");
			setTimeout(() => {
				if (checkRemaininUpsellItems() == 0) {
					document
						.querySelector(".go-cart-drawer__upsell")
						.classList.add("hidden");
				}
			}, 500);
		});
	});
	// Add To Cart Logic - Remove Product From Cart Upsell Pool -- END --
});

// alternative data accordion
const alternativeDataAccordion = () => {
	let data_accordions = document.querySelectorAll(
		"[data-accordion-alternate]"
	);
	if (
		data_accordions != undefined &&
		data_accordions != null &&
		data_accordions.length > 0
	) {
		data_accordions.forEach((accordion) => {
			accordion.addEventListener("click", () => {
				if (accordion.classList.contains("active")) {
					accordion.classList.remove("active");
				} else {
					accordion.classList.add("active");
				}
			});
		});
	}
};
alternativeDataAccordion();

document.addEventListener("DOMContentLoaded", () => {
	function waitForElementToDisplay(
		selector,
		callback,
		checkFrequencyInMs,
		timeoutInMs
	) {
		var startTimeInMs = Date.now();
		(function loopSearch() {
			if (document.querySelector(selector) != null) {
				callback();
				return;
			} else {
				setTimeout(function () {
					if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
						return;
					loopSearch();
				}, checkFrequencyInMs);
			}
		})();
	}

	// Apply styling to Klaviyo back in stock Iframe
	waitForElementToDisplay(
		"#klaviyo-bis-iframe",
		function () {
			const iframe = document.querySelector("#klaviyo-bis-iframe");
			iframe.addEventListener("load", (ev) => {
				const style = document.createElement("style");
				style.textContent = `
          #klaviyo-bis-modal{position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%); }
          #klaviyo-bis-modal > * { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important; }
          #klaviyo-bis-modal button { border-radius: 8px; }
          body #klaviyo-bis-modal > * { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important; }
          html #klaviyo-bis-modal > * { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important; }
        `;
				ev.target.contentDocument.head.appendChild(style);
			});
		},
		1000,
		9000
	);

	// Apply manual classname to collections pages

	if (window.location.href.indexOf("collections/") > -1) {
		waitForElementToDisplay(".snize-add-to-cart-button", function () {
			const addToCartButtons = document.querySelectorAll(
				".snize-add-to-cart-button"
			);
			addToCartButtons.forEach((button) => {
				button.classList.add("weglot_manual");
			});
		});
	}
});
